/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconArrowForward/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconArrowForward({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconArrowForward",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "#353535",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconArrowForward.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z2naMus': alignSelf,'--mt-2-Z2naMus': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z2naMus': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z2naMus': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z2naMus': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z2naMus': opacity,'--w-10-Z2naMus': typeof width === 'number' ? `${width}px` : width,'--h-11-Z2naMus': typeof height === 'number' ? `${height}px` : height,'--f-12-Z2naMus': fill,'--a-7-Z2naMus': isAnimated ? animation : "none",'--sd-8-Z2naMus': isAnimated ? strokeDashoffset : 0,'--sd-9-Z2naMus': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconArrowForward.SvgPath"
  data-view-path={viewPath}
 d="M6.23 20.23L8 22l10-10L8 2 6.23 3.77 14.46 12l-8.23 8.23z"
 className="views-block"
/>
</svg>
{children}
</React.Fragment>)
}